/**
 * Helper method to merge a default array with an incoming array
 * @param array
 * @param defaultArray
 * @returns
 */
export function arrayOrDefault<T>(array: T[], defaultArray: T[]) {
  /**
   * Case 1: The incoming array is empty
   */
  if (array.length === 0) return defaultArray;
  /**
   * Case 2: The incoming array is large enough to replace the defaultArray
   */
  if (array.length >= defaultArray.length) return array;

  /**
   * Case 3: Merge the arrays
   */
  return defaultArray.map((val, i) =>
    array.at(i) !== undefined ? array.at(i) : val
  );
}
